<template>
  <div class="popup-wrap">
    <!-- start: Alert 레이어 팝업 -->
    <div class="layerpop alert" :class="display ? 'show': ''" id="AlertPopup">
      <div class="overlay"></div>
      
      <div class="popup-content">
        <div class="inner">
          <div class="body">
            <div class="alert-box">
              <!-- 아이콘 영역(불필요시 삭제) -->
              <p class="img-wrap">
                <img :src="require(`@/assets/img/common/ico_popup_${icon}.svg`)" alt="">
              </p>
              <h3 class="dsc-bold" v-if="summary">{{ summary }}</h3>
              <p class="dsc-small" v-if="detail">{{ detail }}</p>
            </div>
          </div>
          <div class="btn-wrap">
            <div class="col col-12">
              <button type="button" class="btn lg" @click="close()">{{ t("닫기") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue';
import { useI18n } from "vue-i18n";

const {t} = useI18n();
const props = defineProps({
  display: {
    type    : Boolean,
    required: true,
    default : false,
  },
  icon   : {
    type    : String,
    required: false,
    default : 'warning'
  },
  summary: {
    type    : String,
    required: false,
    default : null
  },
  detail : {
    type    : String,
    required: false,
    default : null
  }
});
const emit = defineEmits(['update:display'])
const close = () => {
  emit("update:display", false)
}
</script>
